import { h } from '@atomify/jsx';

import { CustomValidationRegex } from '../utilities';

interface InputProps extends Partial<CustomValidationRegex> {
    validationTypes?: string | null;
    classes?: string;
    disabled?: boolean;
    readonly?: boolean;
    name: string;
    id: string;
    hook?: string;
    bpdInputHook?: string;
    attr?: { [key: string]: string };
    label: string | Text;
    error?: string;
    type?: string;
    sronly?: boolean;
    placeholder?: string;
    displayName?: string | null;
}

export const InputElement = ({
    validationTypes,
    validationRegex,
    validationErrorMessage,
    requiredErrorMessage,
    maxLength,
    maxLengthErrorMessage,
    value,
    classes,
    disabled,
    name,
    id,
    required,
    hook,
    bpdInputHook,
    attr,
    label,
    error,
    type = 'text',
    sronly,
    displayName,
    readonly,
}: InputProps) => {
    const inputClasses = {
        ['c-input']: true,
        ['form__item']: true,
        ['form__item--disabled']: disabled,
    };

    const attributes: { [key: string]: any } = {
        ...(value && { bindValue: value }),
        ...(bpdInputHook && { [`js-hook-${bpdInputHook}`]: '' }),
    };

    return (
        <bpd-input
            validation-types={validationTypes}
            validation-regex={validationRegex}
            max-length={maxLength}
            validation-error-message={validationErrorMessage}
            required-error-message={requiredErrorMessage}
            max-length-error-message={maxLengthErrorMessage}
            class={classes}
            displayName={displayName}
            {...attributes}>
            <div class={inputClasses}>
                {type === 'hidden' ? (
                    <input
                        class="input__input"
                        name={name}
                        id={id}
                        required={required}
                        disabled={disabled}
                        readonly={readonly}
                        value={value}
                        type={type}
                        {...{ [`js-hook-${hook ? hook : ''}`]: !!hook, ...attr }}
                    />
                ) : (
                    <div class="input__wrapper">
                        <label class={{ ['input__label']: true, ['u-sr-only']: sronly }} for={id}>
                            {label}
                        </label>

                        <input
                            class="input__input"
                            name={name}
                            id={id}
                            required={required}
                            disabled={disabled}
                            readonly={readonly}
                            type={type}
                            maxlength={maxLength}
                            {...{ [`js-hook-${hook ? hook : ''}`]: !!hook, ...attr }}
                        />
                    </div>
                )}

                <div class="form__item-error" role="alert">
                    {error}
                </div>
            </div>
        </bpd-input>
    );
};
